import React from 'react';
import { GetApiKeysResponse } from '@hud/portal-dtos';
import {
  KeyContainer,
  KeyIcon,
  KeysContainer,
  KeyTitle,
  KeyValue,
  KeyValueContainer,
} from './APIKeys.styles';
import { CopyButton } from '@hud/web-components/CopyButton/CopyButton';
import { useBooleanFeatureFlag } from '../../hooks/useFeatureFlags';

export function APIKeys({ keys }: { keys: GetApiKeysResponse['apiKeys'] }) {
  const showSourceMapKeys = useBooleanFeatureFlag('show-source-map-keys');

  // Sort keys in the order: local → staging → production → sourcemap
  const sortedKeys = [...keys].sort((a, b) => {
    const orderMap: Record<string, number> = {
      local: 1,
      staging: 2,
      production: 3,
      'source map': 4,
    };
    const aOrder = orderMap[a.title.toLowerCase()] || 99;
    const bOrder = orderMap[b.title.toLowerCase()] || 99;
    return aOrder - bOrder;
  });

  // Filter out sourcemap keys if feature flag is off
  const filteredKeys = sortedKeys.filter((key) => {
    const isSourceMap = key.title.toLowerCase().includes('source map');
    if (isSourceMap && !showSourceMapKeys) {
      return false;
    }
    return true;
  });

  return (
    <KeysContainer>
      {filteredKeys.map((key) => (
        <KeyContainer key={key.key}>
          <KeyTitle>{key.title}</KeyTitle>
          <KeyValueContainer>
            <KeyIcon />
            <KeyValue>{key.key}</KeyValue>
            <CopyButton value={key.key} />
          </KeyValueContainer>
        </KeyContainer>
      ))}
    </KeysContainer>
  );
}
